"use client";


import React, { createContext, useContext, useState , useEffect} from 'react';

import toast, { Toaster } from "react-hot-toast";
import { useSearchParams } from "next/navigation";

// Creating the FormContext
const FormContext = createContext({
  isFormOpen: false,
  setIsFormOpen: () => {},
  cityDropDown: [],
  properties: [],
  brandId: null,
  setBrandId: () => {},
});

// FormProvider component
export const FormProvider = ({
  children,
  cityDropDown = [],
  properties = [],
}) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [brandId, setBrandId] = useState(null);

  
  const searchParams = useSearchParams();
  // ---- GHA (Google Hotel Ads) deep-link params ----
  const [ghaValidData, setGhaValid] = useState(false);
  const [ghaPropertyIdData, setGhaPropertyId] = useState(null);
  const [ghaCheckInData, setGhaCheckIn] = useState(null);
  const [ghaUtmSourceData,setGhaUtmSource] = useState(null);
  const [ghaCheckOutData, setGhaCheckOut] = useState(null);
  const [ghaAdultsData, setGhaAdults] = useState(null);
  const [ghaChildrenData, setGhaChildren] = useState(null);
    const [ghaPropertyNameData, setGhaPropertyName] = useState(null);
  const [ghaCityNameData, setGhaCityName] = useState(null);
  const [ghaCityIdData, setGhaCityId] = useState(null);
  const [property , setProperty] = useState(properties);
  const [city , setCity] = useState(cityDropDown);

  
  useEffect(() => {
    const getParam = (...keys) => {
      for (const k of keys) {
        const v = searchParams.get(k);
        if (v !== null) return v;
      }
      return null;
    };
//utm_source=GoogleListing
    const pid = getParam("pid");
    
    const utm_source = getParam("utm_source");
    if (utm_source != "GoogleListing" && !pid) return; // normal homepage visit, not a GHA link — do nothing

    const requiredParams = {
      pid,
      checkIn: getParam("checkIn", "checkin"),
      checkOut: getParam("checkOut", "checkout"),
      adults: getParam("adult", "adults"),
      child: getParam("child", "children"),
      source: getParam("source"),
      utm_source,
      utm_campaign: getParam("utm_campaign"),
    };

    const missing = Object.entries(requiredParams)
      .filter(([, v]) => v === null || v === "")
      .map(([k]) => k);

    if (missing.length > 0) {
      // console.error("GHA URL missing required parameter(s):", missing.join(", "));
      // toast.error(`GHA URL missing required parameter(s): "${missing.join('", "')}"`);
      alert(`GHA URL missing required parameter(s): "${missing.join('", "')}"`);
      return;
    }

    let decodedPropertyId = null;
    try {
      decodedPropertyId = decodeURIComponent(escape(atob(pid)));
    } catch (e) {
      console.error("GHA pid could not be decoded:", e);
      toast.error("GHA URL: pid could not be decoded.");
      return;
    }

    let isCancelled = false;

    const getPropertyList = async (prperty) =>{
      if (isCancelled) return;

      const match = prperty?.find(
        (p) => String(p?.staahPropertyId) === String(decodedPropertyId)
      );

      if (!match) {
        console.error("GHA pid did not match any known property:", decodedPropertyId);
        toast.error("GHA URL: property not found for the given pid.");
        return;
      }

      setGhaPropertyId(decodedPropertyId);
      setGhaPropertyName(match?.propertyName || "");
      setGhaCityName(match?.cityName || "");
      setGhaCityId(match?.cityId || null);
      setGhaCheckIn(requiredParams.checkIn);
      setGhaCheckOut(requiredParams.checkOut);
      setGhaAdults(requiredParams.adults);
      setGhaChildren(requiredParams.child);
      setGhaUtmSource(requiredParams?.utm_source);
      setGhaValid(true);

      
 const properties = [
     {
       value: "",
       label: "Select Hotel",
       isDisabled: true,
     }, 
     {
       value: match?.cityName,
       label: match?.propertyName,
       slug: match?.propertySlug,
       url: "",
       propertyName: match?.propertyName,
       staahPropertyId: match?.staahPropertyId,
       offerCode: "",
       propertyId: match?.propertyId,
       hotelBrandId: 1234,
       propertySlug: "",
       staahBookingId: "",
       cityId: match?.cityId,
     }];
  
   const cityDropDown = [
     {
       value: match?.cityId,
       label: match?.cityName,
       propertyData: properties,
     },
   ];
setCity(cityDropDown);
setProperty(properties);
    };

      if(cityDropDown?.length > 0 && properties?.length > 0){
        getPropertyList(properties);
      }
  }, [searchParams, properties, cityDropDown]);

  return (
    <FormContext.Provider
      value={{
        isFormOpen,
        setIsFormOpen,
        cityDropDown:city, 
        properties:property,
        brandId,
        setBrandId,
        // GHA data
        ghaValidData,
        ghaPropertyIdData,
        ghaCheckInData,
        ghaCheckOutData,
        ghaAdultsData,
        ghaChildrenData,
        ghaPropertyNameData,
        ghaCityNameData,
        ghaCityIdData,
        ghaUtmSourceData
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export const useForm = () => useContext(FormContext);
